import axios from 'axios'

export default {
  getKpi (formData) {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.post('/api/report/kpi', formData, {
        headers: {
          Authorization: 'Bearer' + token
        }
      })
        .then((res) => {
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
